<div class="mapping-detail-content">
  <div class="mapping-header-filter-container">
    <mat-form-field appearance="outline" class="client-dropdown">
      <mat-label>{{filterEntityDisplayName}}</mat-label>
      <mat-select (ngModelChange)="beforeFilterEntityDropDownChanged($event)" [(ngModel)]="filterEntityId"
                  name="FilterEntityList">
        <mat-option *ngFor='let filterEntity of filterEntities' [value]="filterEntity.id">{{filterEntity.displayName}}</mat-option>

      </mat-select>
    </mat-form-field>
    <ng-container [ngTemplateOutlet]="typeDropdownTemplate"></ng-container>
  </div>
    <div class="mapping-detail-card">
        <mat-card>
            <mat-card-title>
                {{adminActionLabelText}}
            </mat-card-title>
            <mat-card-content>
                <ng-content select="[mappingFormBody]"></ng-content>
            </mat-card-content>
            <mat-card-footer *ngIf="hasfooter">
                <div class="mapping-detail-footer">
                    <div>
                        <button class="add-new" color="primary" mat-flat-button
                        (click)="openDialog()">
                            <mat-icon>add</mat-icon> 
                            Add New
                        </button>
                    </div>
                    <div>
                        <button class="cancel"
                        color="link" mat-stroked-button
                        (click)="onCancel()" 
                        [disabled]="adminActionLoading"
                        >Cancel</button>
                        <button 
                        class="save" 
                        mat-flat-button 
                        color="primary"
                        [disabled]="buttonIsDisabled"
                        (click)="onSave()">Save</button>
                    </div>
                </div>
                <div class="error-message">
                    <label class="errormsg">{{errorMessage}}</label>
                </div>
            </mat-card-footer>
        </mat-card>
    </div>
    <ng-template #addMappingTemplate>
        <h1 mat-dialog-title>Dialog heading</h1>
        <div mat-dialog-content>
            <ng-container [ngTemplateOutlet]="mappingDialogTemplate"></ng-container>
        </div>
        <div class="mapping-dialog-footer" mat-dialog-actions>
            <button 
            class="cancel"
            color="link" 
            mat-stroked-button
            mat-dialog-close>
                Cancel
            </button>
            <button 
            class="save" 
            mat-flat-button 
            color="primary"
            (click)="onDialogSave()">
                Save
            </button>
        </div>
    </ng-template>
</div>

